module.exports = "/_next/static/images/calendaralt-4284862bb427ba724aa95d51716ee5af.svg";